import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  card: {
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: `2.5px 2.5px 8px ${theme.palette.grey.light}`,
    borderRadius: 4,
    marginBottom: theme.spacing(1.5),
    overflow: "hidden",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1, 1.5),
    backgroundColor: theme.palette.header,
    color: theme.palette.text.secondary,
  },
  cardContent: {
    padding: theme.spacing(1.5),
  },
  noteText: {
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
  editableText: {
    cursor: "pointer",
  },
  pinButton: {
    color: theme.palette.primary.main,
  },
  deleteButton: {
    color: theme.palette.secondary.main,
  },
}));
